module.exports = __webpack_public_path__ + "static/img/royce_hall.fafa0b91.jpg";